import Vue from 'vue'
export default {
  uppercase: Vue.directive('uppercase', {
    bind (el) {
      var inputField = el.getElementsByTagName('input')[0]
      inputField.style.textTransform = 'uppercase'
      inputField.setAttribute('pattern', '[A-Z]{3}')
    }
  })
}
